var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 34,
    viewBox: "0 0 95 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9L17 7",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11L19 9",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11L19 7",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8L16 7",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11L19 10",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11L19 8",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10L18 7",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9L3 7",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 33L11 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 31L9 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 29L7 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27L5 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23L3 21",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21L3 19",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19L3 17",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17L3 15",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15L3 13",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13L3 11",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11L3 9",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25L3 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3 33L11 25",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5 33L11 27",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7 33L11 29",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9 33L11 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11 33L13 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13 33L15 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33L17 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33L19 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33L27 25",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33L27 27",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23 33L27 29",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33L27 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25L25 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27L27 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24L24 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26L26 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18 33L27 24",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33L27 26",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33L27 28",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33L27 30",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8 33L11 30",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10 33L12 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33L14 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33L16 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16 33L18 31",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2 33L11 24",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M4 33L11 26",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6 33L11 28",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32L10 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1 30L8 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1 28L6 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1 26L4 23",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1 22L3 20",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24L3 22",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20L3 18",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18L3 16",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16L3 14",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14L3 12",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12L3 10",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10L3 8",
    stroke: "#00CDEE",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3L9 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3L9 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3L11 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3L13 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3L15 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3L17 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5L19 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7L21 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7L23 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M23 3L25 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3L27 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3L29 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M29 3L31 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M31 3L33 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M31 5L33 3",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M31 7L33 5",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M31 9L33 7",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11L33 9",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13L33 11",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M31 15L33 13",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M31 17L33 15",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19L33 17",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25L33 19",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27L33 21",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31L33 25",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29L33 23",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3L10 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3L12 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L14 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3L16 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4L18 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6L20 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7L22 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7L24 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3L26 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26 3L28 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28 3L30 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3L32 1",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M31 4L33 2",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6L33 4",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8L33 6",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31 10L33 8",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M31 12L33 10",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31 14L33 12",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16L33 14",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18L33 16",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24L33 18",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26L33 20",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M27 28L33 22",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30L33 24",
    stroke: "#00CDEE",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4L8 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6L10 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7L11 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8L12 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9L13 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10L14 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11L15 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12L15 4",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13L15 5",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14L15 6",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15L15 7",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16L15 8",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17L15 9",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18L15 10",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19L15 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19L16 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19L17 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19L18 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7L27 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19L19 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M23 8L28 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19L20 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5L25 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6L26 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4L24 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10L30 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19L22 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9L29 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19L21 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19L31 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20L31 4",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21L31 5",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23L31 7",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22L31 6",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24L31 8",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5L9 3",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26L31 10",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19L31 12",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27L23 20",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27L31 11",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25L31 9",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19L31 13",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27L23 21",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19L31 15",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27L23 23",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19L31 14",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27L23 22",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27L23 24",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22 27L23 26",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27L23 25",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19L31 16",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19L31 18",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19L31 17",
    stroke: "#00CDEE",
    strokeWidth: 0.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7196 14.4003C43.6411 14.4003 43.5732 14.3721 43.5161 14.3157C43.459 14.2593 43.4305 14.1924 43.4305 14.1148V12.0322L41.0214 7.32773C41.0071 7.29954 41 7.26782 41 7.23258C41 7.16915 41.0214 7.11629 41.0642 7.074C41.1142 7.02467 41.1713 7 41.2356 7H43.2485C43.3698 7 43.4662 7.03172 43.5376 7.09515C43.6161 7.15153 43.6696 7.20791 43.6982 7.2643L44.7689 9.38924L45.8395 7.2643C45.8681 7.20791 45.9181 7.15153 45.9894 7.09515C46.068 7.03172 46.1679 7 46.2892 7H48.3022C48.3664 7 48.4199 7.02467 48.4628 7.074C48.5127 7.11629 48.5377 7.16915 48.5377 7.23258C48.5377 7.26782 48.5306 7.29954 48.5163 7.32773L46.1072 12.0322V14.1148C46.1072 14.1924 46.0787 14.2593 46.0216 14.3157C45.9645 14.3721 45.8967 14.4003 45.8181 14.4003H43.7196Z",
    fill: "#00CDEE"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3233 14.506C52.2526 14.506 51.4032 14.2664 50.775 13.7871C50.154 13.3008 49.8435 12.5749 49.8435 11.6093V7.28544C49.8435 7.20791 49.8721 7.14096 49.9292 7.08457C49.9863 7.02819 50.0541 7 50.1326 7H52.2312C52.3097 7 52.3775 7.02819 52.4346 7.08457C52.4917 7.14096 52.5203 7.20791 52.5203 7.28544V11.567C52.5203 11.8349 52.5845 12.0392 52.713 12.1802C52.8486 12.3141 53.0485 12.3811 53.3126 12.3811C53.5767 12.3811 53.773 12.3141 53.9015 12.1802C54.0371 12.0392 54.1049 11.8349 54.1049 11.567V7.28544C54.1049 7.20791 54.1335 7.14096 54.1906 7.08457C54.2477 7.02819 54.3155 7 54.394 7H56.4926C56.5711 7 56.6389 7.02819 56.696 7.08457C56.7531 7.14096 56.7816 7.20791 56.7816 7.28544V11.6093C56.7816 12.5749 56.4711 13.3008 55.8501 13.7871C55.2291 14.2664 54.3869 14.506 53.3233 14.506Z",
    fill: "#00CDEE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9348 14.4003C58.8562 14.4003 58.7884 14.3721 58.7313 14.3157C58.6742 14.2593 58.6457 14.1924 58.6457 14.1148V7.28544C58.6457 7.20791 58.6742 7.14096 58.7313 7.08457C58.7884 7.02819 58.8562 7 58.9348 7H62.179C63.1783 7 63.9635 7.21848 64.5345 7.65545C65.1127 8.09242 65.4018 8.73731 65.4018 9.5901C65.4018 10.4358 65.1162 11.0666 64.5452 11.4825C63.9742 11.8912 63.1854 12.0956 62.179 12.0956H61.4295V14.1148C61.4295 14.1924 61.4009 14.2593 61.3438 14.3157C61.2867 14.3721 61.2189 14.4003 61.1404 14.4003H58.9348ZM62.1254 10.1398C62.2539 10.1398 62.3681 10.094 62.4681 10.0024C62.568 9.90373 62.618 9.75925 62.618 9.56896C62.618 9.40686 62.5787 9.2659 62.5002 9.14608C62.4217 9.02627 62.2967 8.96636 62.1254 8.96636H61.3759V10.1398H62.1254Z",
    fill: "#00CDEE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0055 14.4003C65.9413 14.4003 65.8842 14.3791 65.8342 14.3369C65.7914 14.2875 65.77 14.2311 65.77 14.1677C65.77 14.1395 65.7736 14.1148 65.7807 14.0937L68.1683 7.34887C68.1969 7.25725 68.2504 7.1762 68.3289 7.10572C68.4075 7.03524 68.5145 7 68.6502 7H70.9736C71.1092 7 71.2163 7.03524 71.2948 7.10572C71.3733 7.1762 71.4268 7.25725 71.4554 7.34887L73.843 14.0937C73.8502 14.1148 73.8537 14.1395 73.8537 14.1677C73.8537 14.2311 73.8288 14.2875 73.7788 14.3369C73.736 14.3791 73.6824 14.4003 73.6182 14.4003H71.6374C71.4233 14.4003 71.2841 14.3122 71.2198 14.136L70.9629 13.4383H68.6609L68.4039 14.136C68.3397 14.3122 68.2005 14.4003 67.9863 14.4003H66.0055ZM69.2069 11.3767H70.4168L69.8065 9.41038L69.2069 11.3767Z",
    fill: "#00CDEE"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4799 14.4003C75.4014 14.4003 75.3336 14.3721 75.2765 14.3157C75.2194 14.2593 75.1909 14.1924 75.1909 14.1148V7.28544C75.1909 7.20791 75.2194 7.14096 75.2765 7.08457C75.3336 7.02819 75.4014 7 75.4799 7H77.1716C77.3715 7 77.5178 7.08105 77.6106 7.24315L79.4201 10.1716V7.28544C79.4201 7.20791 79.4487 7.14096 79.5058 7.08457C79.5629 7.02819 79.6307 7 79.7092 7H81.6472C81.7257 7 81.7935 7.02819 81.8506 7.08457C81.9077 7.14096 81.9362 7.20791 81.9362 7.28544V14.1148C81.9362 14.1924 81.9077 14.2593 81.8506 14.3157C81.7935 14.3721 81.7257 14.4003 81.6472 14.4003H79.9555C79.8341 14.4003 79.7413 14.3756 79.6771 14.3263C79.6128 14.277 79.5593 14.2206 79.5165 14.1571L77.707 11.4613V14.1148C77.707 14.1924 77.6784 14.2593 77.6213 14.3157C77.5642 14.3721 77.4964 14.4003 77.4179 14.4003H75.4799Z",
    fill: "#00CDEE"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5127 14.4003C83.4484 14.4003 83.3913 14.3791 83.3414 14.3369C83.2985 14.2875 83.2771 14.2311 83.2771 14.1677C83.2771 14.1395 83.2807 14.1148 83.2878 14.0937L85.6755 7.34887C85.704 7.25725 85.7576 7.1762 85.8361 7.10572C85.9146 7.03524 86.0217 7 86.1573 7H88.4807C88.6163 7 88.7234 7.03524 88.8019 7.10572C88.8804 7.1762 88.934 7.25725 88.9625 7.34887L91.3502 14.0937C91.3573 14.1148 91.3609 14.1395 91.3609 14.1677C91.3609 14.2311 91.3359 14.2875 91.2859 14.3369C91.2431 14.3791 91.1896 14.4003 91.1253 14.4003H89.1445C88.9304 14.4003 88.7912 14.3122 88.727 14.136L88.47 13.4383H86.168L85.911 14.136C85.8468 14.3122 85.7076 14.4003 85.4935 14.4003H83.5127ZM86.7141 11.3767H87.924L87.3136 9.41038L86.7141 11.3767Z",
    fill: "#00CDEE"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8479 14.4003C92.7694 14.4003 92.7016 14.3721 92.6445 14.3157C92.5874 14.2593 92.5588 14.1924 92.5588 14.1148V12.2753C92.5588 12.1978 92.5874 12.1309 92.6445 12.0745C92.7016 12.0181 92.7694 11.9899 92.8479 11.9899H94.7109C94.7894 11.9899 94.8572 12.0181 94.9143 12.0745C94.9714 12.1309 95 12.1978 95 12.2753V14.1148C95 14.1924 94.9714 14.2593 94.9143 14.3157C94.8572 14.3721 94.7894 14.4003 94.7109 14.4003H92.8479Z",
    fill: "#00CDEE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8459 26.8943C41.7673 26.8943 41.6995 26.8661 41.6424 26.8097C41.5853 26.7533 41.5568 26.6864 41.5568 26.6088V19.7794C41.5568 19.7019 41.5853 19.635 41.6424 19.5786C41.6995 19.5222 41.7673 19.494 41.8459 19.494H47.2422C47.3207 19.494 47.3885 19.5222 47.4456 19.5786C47.5027 19.635 47.5312 19.7019 47.5312 19.7794V21.3864C47.5312 21.4639 47.5027 21.5308 47.4456 21.5872C47.3885 21.6436 47.3207 21.6718 47.2422 21.6718H44.18V22.4541H47.028C47.1065 22.4541 47.1744 22.4823 47.2315 22.5387C47.2886 22.5951 47.3171 22.662 47.3171 22.7395V24.3359C47.3171 24.4134 47.2886 24.4804 47.2315 24.5368C47.1744 24.5931 47.1065 24.6213 47.028 24.6213H44.18V26.6088C44.18 26.6864 44.1514 26.7533 44.0943 26.8097C44.0372 26.8661 43.9694 26.8943 43.8909 26.8943H41.8459Z",
    fill: "#00CDEE"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5172 26.8943C49.4387 26.8943 49.3709 26.8661 49.3138 26.8097C49.2567 26.7533 49.2281 26.6864 49.2281 26.6088V19.7794C49.2281 19.7019 49.2567 19.635 49.3138 19.5786C49.3709 19.5222 49.4387 19.494 49.5172 19.494H51.7014C51.78 19.494 51.8478 19.5222 51.9049 19.5786C51.962 19.635 51.9905 19.7019 51.9905 19.7794V26.6088C51.9905 26.6864 51.962 26.7533 51.9049 26.8097C51.8478 26.8661 51.78 26.8943 51.7014 26.8943H49.5172Z",
    fill: "#00CDEE"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2086 26.8943C54.1301 26.8943 54.0623 26.8661 54.0052 26.8097C53.9481 26.7533 53.9195 26.6864 53.9195 26.6088V19.7794C53.9195 19.7019 53.9481 19.635 54.0052 19.5786C54.0623 19.5222 54.1301 19.494 54.2086 19.494H55.9003C56.1002 19.494 56.2465 19.575 56.3393 19.7371L58.1488 22.6655V19.7794C58.1488 19.7019 58.1773 19.635 58.2345 19.5786C58.2916 19.5222 58.3594 19.494 58.4379 19.494H60.3758C60.4544 19.494 60.5222 19.5222 60.5793 19.5786C60.6364 19.635 60.6649 19.7019 60.6649 19.7794V26.6088C60.6649 26.6864 60.6364 26.7533 60.5793 26.8097C60.5222 26.8661 60.4544 26.8943 60.3758 26.8943H58.6841C58.5628 26.8943 58.47 26.8696 58.4058 26.8203C58.3415 26.7709 58.288 26.7146 58.2452 26.6511L56.4357 23.9553V26.6088C56.4357 26.6864 56.4071 26.7533 56.35 26.8097C56.2929 26.8661 56.2251 26.8943 56.1466 26.8943H54.2086Z",
    fill: "#00CDEE"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2414 26.8943C62.1771 26.8943 62.12 26.8731 62.0701 26.8308C62.0272 26.7815 62.0058 26.7251 62.0058 26.6617C62.0058 26.6335 62.0094 26.6088 62.0165 26.5877L64.4042 19.8429C64.4327 19.7512 64.4863 19.6702 64.5648 19.5997C64.6433 19.5292 64.7504 19.494 64.886 19.494H67.2094C67.345 19.494 67.4521 19.5292 67.5306 19.5997C67.6091 19.6702 67.6627 19.7512 67.6912 19.8429L70.0789 26.5877C70.086 26.6088 70.0896 26.6335 70.0896 26.6617C70.0896 26.7251 70.0646 26.7815 70.0146 26.8308C69.9718 26.8731 69.9183 26.8943 69.854 26.8943H67.8732C67.6591 26.8943 67.5199 26.8062 67.4557 26.63L67.1987 25.9322H64.8967L64.6397 26.63C64.5755 26.8062 64.4363 26.8943 64.2222 26.8943H62.2414ZM65.4427 23.8707H66.6526L66.0423 21.9044L65.4427 23.8707Z",
    fill: "#00CDEE"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7158 26.8943C71.6373 26.8943 71.5694 26.8661 71.5123 26.8097C71.4552 26.7533 71.4267 26.6864 71.4267 26.6088V19.7794C71.4267 19.7019 71.4552 19.635 71.5123 19.5786C71.5694 19.5222 71.6373 19.494 71.7158 19.494H73.4075C73.6073 19.494 73.7537 19.575 73.8465 19.7371L75.6559 22.6655V19.7794C75.6559 19.7019 75.6845 19.635 75.7416 19.5786C75.7987 19.5222 75.8665 19.494 75.945 19.494H77.883C77.9615 19.494 78.0293 19.5222 78.0864 19.5786C78.1435 19.635 78.1721 19.7019 78.1721 19.7794V26.6088C78.1721 26.6864 78.1435 26.7533 78.0864 26.8097C78.0293 26.8661 77.9615 26.8943 77.883 26.8943H76.1913C76.0699 26.8943 75.9771 26.8696 75.9129 26.8203C75.8487 26.7709 75.7951 26.7146 75.7523 26.6511L73.9428 23.9553V26.6088C73.9428 26.6864 73.9143 26.7533 73.8572 26.8097C73.8001 26.8661 73.7323 26.8943 73.6537 26.8943H71.7158Z",
    fill: "#00CDEE"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4959 27C82.4181 27 81.5616 26.7674 80.9263 26.3023C80.291 25.83 79.9519 25.1076 79.9091 24.135C79.902 23.9447 79.8984 23.6346 79.8984 23.2047C79.8984 22.7677 79.902 22.4506 79.9091 22.2532C79.9519 21.3088 80.2981 20.597 80.9477 20.1177C81.5972 19.6314 82.4467 19.3883 83.4959 19.3883C84.1384 19.3883 84.7273 19.4834 85.2626 19.6737C85.8051 19.864 86.2441 20.1635 86.5796 20.5723C86.9222 20.9741 87.0971 21.4815 87.1042 22.0947C87.1042 22.1581 87.0792 22.2145 87.0292 22.2638C86.9864 22.3061 86.9329 22.3272 86.8686 22.3272H84.6844C84.5702 22.3272 84.4846 22.3061 84.4275 22.2638C84.3775 22.2215 84.3311 22.1405 84.2883 22.0207C84.2097 21.8092 84.1062 21.6612 83.9778 21.5766C83.8493 21.4921 83.6851 21.4498 83.4852 21.4498C83.2354 21.4498 83.0427 21.5167 82.9071 21.6506C82.7714 21.7775 82.7001 21.996 82.6929 22.3061C82.6858 22.4964 82.6822 22.7889 82.6822 23.1836C82.6822 23.5782 82.6858 23.8778 82.6929 24.0822C82.7001 24.3923 82.7714 24.6143 82.9071 24.7482C83.0427 24.8751 83.2354 24.9385 83.4852 24.9385C83.8921 24.9385 84.1598 24.7482 84.2883 24.3676C84.324 24.2478 84.3668 24.1667 84.4167 24.1245C84.4739 24.0822 84.5631 24.061 84.6844 24.061H86.8686C86.9329 24.061 86.9864 24.0857 87.0292 24.135C87.0792 24.1773 87.1042 24.2302 87.1042 24.2936C87.0971 24.9068 86.9222 25.4177 86.5796 25.8265C86.2441 26.2283 85.8051 26.5243 85.2626 26.7146C84.7273 26.9049 84.1384 27 83.4959 27Z",
    fill: "#00CDEE"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9929 26.8943C88.9144 26.8943 88.8466 26.8661 88.7895 26.8097C88.7324 26.7533 88.7038 26.6864 88.7038 26.6088V19.7794C88.7038 19.7019 88.7324 19.635 88.7895 19.5786C88.8466 19.5222 88.9144 19.494 88.9929 19.494H94.4856C94.5641 19.494 94.6319 19.5222 94.689 19.5786C94.7461 19.635 94.7747 19.7019 94.7747 19.7794V21.2701C94.7747 21.3476 94.7461 21.4145 94.689 21.4709C94.6319 21.5273 94.5641 21.5555 94.4856 21.5555H91.2735V22.2215H94.25C94.3285 22.2215 94.3963 22.2497 94.4534 22.3061C94.5105 22.3625 94.5391 22.4294 94.5391 22.507V23.8813C94.5391 23.9588 94.5105 24.0258 94.4534 24.0822C94.3963 24.1386 94.3285 24.1667 94.25 24.1667H91.2735V24.8328H94.5712C94.6497 24.8328 94.7175 24.861 94.7747 24.9173C94.8318 24.9737 94.8603 25.0407 94.8603 25.1182V26.6088C94.8603 26.6864 94.8318 26.7533 94.7747 26.8097C94.7175 26.8661 94.6497 26.8943 94.5712 26.8943H88.9929Z",
    fill: "#00CDEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.18145310699e53767732118a5b128e79.svg";
export { ForwardRef as ReactComponent };